angular.module('agreements')
    .controller('AgreementAccessGroupDialogController', function ($rootScope, $uibModalInstance, data, toastr, AgreementAccessGroup, AgreementAccessGroupConst) {
        this.$onInit = () => {
            this.item = data
        }

        this.cancel = () => $uibModalInstance.dismiss()

        this.save = () => {
            let $promise
            if (this.item.id !== null) {
                $promise = AgreementAccessGroup.update(this.item).$promise
            } else {
                $promise = AgreementAccessGroup.save(this.item).$promise
            }
            return $promise
                .then(result => {
                    $rootScope.$broadcast(AgreementAccessGroupConst.eventUpdate)
                    $uibModalInstance.close(result)
                    toastr.success("Zapisano")
                })
        }
    })
